import React from 'react'
import Text from '../Text'
import FlexLayout from '../FlexLayout'
import { ErrorMessage } from 'formik'
import {fieldStyle, fieldDisabledStyle} from './style'
import NumberFormat from 'react-number-format'

function FormFieldNumber({name,
                            label,
                            value, 
                            onKeyPress, 
                            onBlur, 
                            onValueChange,
                            onKeyDown,
                            style,
                            styleContainer,
                            isDisabled = false,
                            allowEmptyFormatting = false, 
                            decimalSeparator = ',', 
                            thousandSeparator = '.', 
                            decimalScale = 0,           
                            allowLeadingZeros = false, 
                            allowNegative = false, 
                            fixedDecimalScale = false,
                            testId = ''}) {
    return (
        <FlexLayout direction="column" style={{ width: "auto", margin: '15px 5px 0 0', ...styleContainer }}>
            <Text textType="default" text={label} />
            <NumberFormat
                name={name}
                decimalSeparator={decimalSeparator}
                thousandSeparator={thousandSeparator}
                decimalScale={decimalScale}
                allowLeadingZeros={allowLeadingZeros}
                allowNegative={allowNegative}
                fixedDecimalScale={fixedDecimalScale}
                allowEmptyFormatting={allowEmptyFormatting}
                value={value}
                {...(onValueChange && {onValueChange : onValueChange})}
                {...(onBlur && {onBlur : onBlur})}
                {...(onKeyDown ? {onKeyDown : onKeyDown}
                                : (evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault())}
                {...(onKeyPress ? {onKeyPress : onKeyPress} : {
                    onKeyPress: (event) => {
                    if(event.key === "Enter") {
                        const submitButton = document.querySelector('.submit-button');
                        const button = document.querySelector('button');
                        const inputs = document.getElementsByTagName('input');
                        const activeInputs = [...inputs].filter((input) => !input.disabled)
        
                        for (let index = 0; index < inputs.length; index++) {
                            if (activeInputs[index] == document.getElementsByName(event.target.name)[0]) {
                            if (index == activeInputs.length - 1) {
                                if (submitButton != null) submitButton.click();
                                else if (button != null) button.click();
                                break;
                            }
                            activeInputs[index+1].focus();
                            }
                        }
                    }
                    }
                }
                )}
                style={{
                    ...fieldStyle,
                    ...style,
                    ...(isDisabled ? fieldDisabledStyle : ""),
                }}
                maxLength={10}
                data-testid={testId}
        />
        <ErrorMessage component={Text} name={name} style={{color:'red'}}/>
      </FlexLayout>
    )
}

export default FormFieldNumber
